import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { InfillTypes, isLaserCutInfill } from '../services/railing/infills/model/infill-types';
import { LASER_CUT_DESIGNS } from '../services/railing/infills/model/laser-cut-designs.config';
import { take, map } from 'rxjs/operators';
import { EditRailingColorService } from '../services/edit-railing-color.service';

@Component({
  selector: 'app-edit-infill',
  templateUrl: './edit-infill.component.html',
  styleUrls: ['./edit-infill.component.scss']
})
export class EditInfillComponent implements OnInit {
  @Output() step2Editer = new EventEmitter();
  horizontal = true;
  pickets = true;
  vertical = true;
  // glass = true;
  horizontalCableBaserail = true;
  glassList = true;
  laserCutList = true;
  steelMeshList = true;
  isShowIntermediate = true;
  isShowConcealKits = true;
  isShowStSteelEndCaps = true;
  isShowStSteelPickets = true;
  isShowStandartCablerailKits = true;
  submenu = {
    showLaserCutVariants: false,
    showGlassTypesVariants: false,
    showSteelMeshVariants: false,
    showIntermediateRailForPicket: false,
    showIntermediateRailForVertCable: false,
    showIntermediateRailForGlass: false,
    showIntermediateRailForHorCableBottomRail: false,
    showIntermediateRailForHorCable: false,
  };

  laserCutDesigns = LASER_CUT_DESIGNS;
  selectedInfill = this._buildSelectionMap();
  hoveredLaserDesign: string = null;

  railingType: string;
  currentInfillName: string = null;
  picketSelectionMenuAvailable = false;
  infillStSteelPickets = false;

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    public editRailingColorService: EditRailingColorService,
    ) {
    this.dataForMenu.railingType.subscribe(value => {
      this.railingType = value;
      switch (this.railingType) {
        case 'DesignRail': {
          this.horizontal = true;
          this.pickets = true;
          this.vertical = true;
          this.horizontalCableBaserail = true;
          this.glassList = true;
          this.laserCutList = true;
          this.steelMeshList = true;
          this.isShowConcealKits = true;
          this.isShowIntermediate = true;
          this.isShowStSteelEndCaps = true;
          this.isShowStSteelPickets = true;
          this.isShowStandartCablerailKits = true;
          break;
        }
        case 'Wood': {
          this.horizontal = true;
          this.pickets = false;
          this.vertical = false;
          this.horizontalCableBaserail = true;
          this.glassList = false;
          this.laserCutList = false;
          this.steelMeshList = false;
          this.isShowIntermediate = false;
          this.isShowConcealKits = true;
          this.isShowStSteelEndCaps = true;
          this.isShowStSteelPickets = true;
          this.isShowStandartCablerailKits = true;
          break;
        }
        case 'Composite': {
          this.horizontal = true;
          this.pickets = false;
          this.vertical = false;
          this.horizontalCableBaserail = true;
          this.glassList = false;
          this.laserCutList = false;
          this.steelMeshList = false;
          this.isShowConcealKits = false;
          this.isShowIntermediate = false;
          this.isShowStSteelEndCaps = false;
          this.isShowStSteelPickets = false;
          this.isShowStandartCablerailKits = false;
          break;
        }
        case 'Steel flat bar': {
          this.horizontal = true;
          this.pickets = false;
          this.vertical = false;
          this.horizontalCableBaserail = true;
          this.glassList = false;
          this.laserCutList = false;
          this.steelMeshList = false;
          this.isShowConcealKits = false;
          this.isShowIntermediate = false;
          this.isShowStSteelEndCaps = true;
          this.isShowStSteelPickets = false;
          this.isShowStandartCablerailKits = false;
          break;
        }
        case 'Steel round tubular': {
          this.horizontal = true;
          this.pickets = false;
          this.vertical = false;
          this.horizontalCableBaserail = true;
          this.glassList = false;
          this.laserCutList = false;
          this.steelMeshList = false;
          this.isShowConcealKits = false;
          this.isShowIntermediate = false;
          this.isShowStSteelEndCaps = true;
          this.isShowStSteelPickets = false;
          this.isShowStandartCablerailKits = false;
          break;
        }
        case 'Modern': {
          // single 'modern' option (spec p.8) riding the horizontalCable
          // pipeline; no cable sub-options apply to the slat kit
          this.horizontal = true;
          this.pickets = false;
          this.vertical = false;
          this.horizontalCableBaserail = false;
          this.glassList = false;
          this.laserCutList = false;
          this.steelMeshList = false;
          this.isShowConcealKits = false;
          this.isShowIntermediate = false;
          this.isShowStSteelEndCaps = false;
          this.isShowStSteelPickets = false;
          this.isShowStandartCablerailKits = false;
          break;
        }
      }
      this._setpicketSelectionMenuAvailable();
    });
    dataForMenu.infill.subscribe((value: string) => {
      this.currentInfillName = value;
      this.setSelectedSettings(value);
      this._setpicketSelectionMenuAvailable();
    });
    dataForMenu.infillStSteelPicketsUpdated.subscribe(value => {
      this.infillStSteelPickets = value;
    });
  }

  private _setpicketSelectionMenuAvailable() {
    if (
      (this.dataForMenu.currentChoises.infill === 'horizontalCable' ||
        this.dataForMenu.currentChoises.infill === 'horizontalCableBaserail') &&
      this.dataForMenu.currentChoises.railingType === 'Wood'
    ) {
      this.picketSelectionMenuAvailable = true;
    } else {
      this.picketSelectionMenuAvailable = false;
    }
  }

  ngOnInit() {}

  selectTypeColor(option) {
    const selectedSteelForWood = {
      name: 'Stainless Steel (tubular)',
      shapeType: 'Tubular',
      color: '#DADADA',
      colorName: 'Stainless'
    };
    const selectedSilverForWood = {
      name: 'Silver Aluminum (square)',
      shapeType: 'Square',
      color: '#B4BABB',
      colorName: 'Silver'
    };
    const selectedSteel = {
      id: '5e67a64974ba3c5e0a45769f',
      name: 'Stainless Steel',
      // texture: 'https://feeney.interiordesigntools.com/api/containers/images/download/Feeney_stainless_steel.jpg',
      rgb: 'rgb(218, 218, 218)'
    };
    const selectedBlack = {
      name: 'Black',
      rgb: 'rgb(35, 35, 35)',
      rColor: '35',
      gColor: '35',
      bColor: '35',
      id: '5afafb9151c80c643ac6ff6e'
    };
    const type = {
      colors: [],
      defaults: 'Black',
      productTypes: ['Vertical Picket'],
      selected: {
        name: 'Black',
        rgb: 'rgb(35, 35, 35)',
        rColor: '35',
        gColor: '35',
        bColor: '35',
        id: '5afafb9151c80c643ac6ff6e'
      },
      type: 'Picket',
      visible: true
    };

    if (this.dataForMenu.currentChoises.railingType === 'Wood') {
      if (this.dataForMenu.getRailOptions(option)) {
        this.dataForMenu.setVerticalPicket(
          selectedSilverForWood.shapeType,
          selectedSilverForWood.colorName
        );
      } else {
        this.dataForMenu.setVerticalPicket(
          selectedSteelForWood.shapeType,
          selectedSteelForWood.colorName
        );
      }
    } else if (this.dataForMenu.getRailOptions(option)) {
      this.editRailingColorService.selectTypeColor(type, selectedBlack, true);
    } else {
      this.editRailingColorService.selectTypeColor(type, selectedSteel, true);
    }
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
    // http://146.185.164.175:8080/browse/FR-930
    this.dataForMenu.infill
      .pipe(
        take(1),
        map((value: string) => {
          this.setSelectedSettings(value);
        })
      )
      .subscribe();
  }

  setInfill(value: string) {
    this.dataForMenu.setInfill(value);
  }

  checkInfillOptions(infill, option) {
    if (this.currentInfillName === infill && this.dataForMenu.getRailOptions(option)) {
      return true;
    } else {
      return false;
    }
  }

  checkStandardCableAndConcealIntersection(option) {
    if (option === 'infillStandartCablerailKits') {
      if (this.dataForMenu.getRailOptions(option)) {
        this.dataForMenu.setRailOptions(option, false);
        this.dataForMenu.setRailOptions('infillConcealKits', true);
      } else {
        this.dataForMenu.setRailOptions(option, true);
        this.dataForMenu.setRailOptions('infillConcealKits', false);
      }
    }
    if (option === 'infillConcealKits') {
      if (this.dataForMenu.getRailOptions(option)) {
        this.dataForMenu.setRailOptions(option, false);
        this.dataForMenu.setRailOptions('infillStandartCablerailKits', true);
      } else {
        this.dataForMenu.setRailOptions(option, true);
        this.dataForMenu.setRailOptions('infillStandartCablerailKits', false);
      }
    }
  }

  setRailOptions(value) {
    if (value === 'infillStandartCablerailKits' || value === 'infillConcealKits') {
      this.checkStandardCableAndConcealIntersection(value);
    } else {
      if (this.dataForMenu.getRailOptions(value)) {
        this.dataForMenu.setRailOptions(value, false);
      } else {
        this.dataForMenu.setRailOptions(value, true);
      }
    }
  }

  resetRailOptions() {
    const infills = [
      'infillConcealKits', 'infillStandartCablerailKits', 'infillIntermediateRail', 'infillStSteelEndCaps'
    ];
    infills.forEach(el => {
      if (el === 'infillStandartCablerailKits') {
        this.dataForMenu.setRailOptions(el, true);
      } else {
        this.dataForMenu.setRailOptions(el, false);
      }
    });
  }

  setSelectedSettings(value: string) {
    this.clearSelection();
    this.hideSubMenu();
    switch (value) {
      case 'horizontalCable': {
        this.selectedInfill.horizontal = true;
        this.submenu.showIntermediateRailForHorCable = true;
        break;
      }
      case 'verticalPicket': {
        this.selectedInfill.pickets = true;
        this.submenu.showIntermediateRailForPicket = true;
        break;
      }
      case 'verticalCable': {
        this.selectedInfill.vertical = true;
        this.submenu.showIntermediateRailForVertCable = true;
        break;
      }
      // case 'glass':
      case InfillTypes.glassClear:
      case InfillTypes.glassDark:
      case InfillTypes.glassSmoke: {
        this.submenu.showGlassTypesVariants = true;
        this.selectedInfill[value] = true;
        break;
      }
      case 'horizontalCableBaserail': {
        this.selectedInfill.horizontalCableBaserail = true;
        this.submenu.showIntermediateRailForHorCableBottomRail = true;
        break;
      }
      default: {
        if (isLaserCutInfill(value)) {
          this.submenu.showLaserCutVariants = true;
          this.selectedInfill[value] = true;
        } else if (value && value.indexOf('steelMesh') === 0) {
          this.submenu.showSteelMeshVariants = true;
          this.selectedInfill[value] = true;
        }
        break;
      }
    }
  }

  private _buildSelectionMap() {
    const map = {
      horizontal: false,
      pickets: false,
      vertical: false,
      horizontalCableBaserail: false
    };
    Object.keys(InfillTypes).forEach(key => (map[key] = false));
    return map;
  }

  clearSelection() {
    this.selectedInfill = this._buildSelectionMap();
  }

  hideSubMenu() {
    this.submenu = {
      showLaserCutVariants: false,
      showGlassTypesVariants: false,
      showSteelMeshVariants: false,
      showIntermediateRailForPicket: false,
      showIntermediateRailForVertCable: false,
      showIntermediateRailForGlass: false,
      showIntermediateRailForHorCableBottomRail: false,
      showIntermediateRailForHorCable: false,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/edit-infill/edit-infill.component.ts